define('drops/listItem/listItem',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/util',
    'when'
], function ($, _, Drop, Style, util, when) {
    'use strict';

    var defaults = {
        data: {
            styles: { normal: {}, enabled: true },
            randomRotateOffset: 0
        }
    };

    function ListItem(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.positioning = 'relative';
        this.data.styles = util.convertListOfKeyValuesToObject(this.data.styles);

        this.$element
            .addClass('boxToBorderSize has-states')
            .css({
                whiteSpace: 'pre-wrap'
            });

        Style.renderStyles(this, undefined, undefined, undefined, 'normal');

        this.addListener('ChildAdded', this.applyDataAndVisibilityToChild.bind(this));

        this.children = [];
    }

    Drop.extend(ListItem);

    ListItem.typeName = 'ListItem';

    ListItem.prototype.applyDataAndVisibilityToChild = function (childDrop) {
        if (childDrop.type === 'List' && childDrop.data.useParentGroupData && this.dataRow && this.dataRow.$groupData) {
            childDrop.setData(this.dataRow.$groupData);
        } else {
            var self = this;
            childDrop.addListener('ChildAdded',
                function(childDrop) {
                    self.applyDataAndVisibilityToChild(childDrop);
                });

            this.children.push(childDrop);

            if (childDrop['licquidMethod_load'])
                childDrop.licquidMethod_load();
        }
    };

    ListItem.prototype.setData = function (outputs, dataRow) {
        this.outputs = outputs;

        if (this.dataRow) {
            var self = this;
            _.forEach(_.keys(outputs), function (output) {
                self.dataRow[output] = dataRow[output];
            });
        } else {
            this.dataRow = dataRow;
        }
    };

    ListItem.prototype.getData = function () {
        return this.dataRow;
    };

    ListItem.prototype.createChildren = function () {
        var drops = this.piping.dropFactory
            .createDrops(this.childDrops, { dynamic: true });

        var self = this;
        _.each(drops, function (drop) {
            drop.defaultEventArg = self.defaultEventArg;
            self.addDrop(drop);
        });
    };

    ListItem.prototype.preRender = function () {
        if (this.parent.data.layout === "Horizontal") {
            this.left = undefined;
            this.right = undefined;
        } else if (this.parent.data.layout === "Vertical") {
            this.top = undefined;
            this.bottom = undefined;
        } else {
            this.left = undefined;
            this.right = undefined;
            this.top = undefined;
            this.bottom = undefined;
        }
        this.applyPosition();
        return this.createChildren();
    };

    ListItem.prototype.render = function ($element, isReversed) {
        var self = this;

        return when(self.preRender())
            .then(function () {
                if (self.removed)
                    return;
                if (isReversed)
                    self.$element.prependTo($element);
                else
                    self.$element.appendTo($element);

                var renderPromises = [];

                _.forEach(self.pool, function (drop) {
                    renderPromises.push(self.createRenderPromiseForChild(drop));
                });

                return when.all(renderPromises);
            })
            .then(function () {
                return self.postRender();
            });
    };

    ListItem.prototype.postRender = function () {
        var rotationdiff = this.data.randomRotateOffset;
        if (rotationdiff) {
            var rotation = 0;

            var currentRotationAsMatrix = this.$element.css('transform');
            if (currentRotationAsMatrix && currentRotationAsMatrix !== "none") {
                var matrixValues = currentRotationAsMatrix.split('(')[1].split(')')[0].split(',');
                rotation = Math.round(Math.atan2(matrixValues[1], matrixValues[0]) * (180 / Math.PI));
            }

            var randomdiff = Math.floor((Math.random() * rotationdiff * 2) - rotationdiff);
            var newrotation = rotation + randomdiff;

            this.$element.css('-webkit-transform', "rotate(" + newrotation + "deg)");
            this.$element.css('-moz-transform', "rotate(" + newrotation + "deg)");
            this.$element.css('-o-transform', "rotate(" + newrotation + "deg)");
            this.$element.css('-ms-transform', "rotate(" + newrotation + "deg)");
            this.$element.css('transform', "rotate(" + newrotation + "deg)");
        }
        this.calculateSizeBasedOnRatio();

        this.reapplyData();
    };

    ListItem.prototype.reapplyData = function () {
        if (!this.dataRow)
            return;

        var self = this;
        _.each(this.children, function (childDrop) {
            if (childDrop.setValue && self.outputs && _.has(self.dataRow, childDrop.data.name)) {
                childDrop.setValue({
                    type: self.outputs[childDrop.data.name],
                    value: self.dataRow[childDrop.data.name]
                });
            }

            childDrop.informListeners('DatasourceApplied', self.dataRow);
        });
    };

    ListItem.prototype.applyPositionForChild = function (childDrop) {
        if (this.parent.data.layout === 'Dynamic Vertical' && childDrop.data.isDynamiclySizedContainer) {
            var css = this.getPositionCss(childDrop.data);
            css.position = 'static';
            childDrop.$element.css(css);
        } else {
            childDrop.$element.css(this.getPositionCss(childDrop.data));
        }
    };

    ListItem.prototype.getStates = function () {
        return [
            { key: 'normal', value: 'Normal' },
            { key: 'hover', value: 'Hover' },
            { key: 'selected', value: 'Selected' }
        ];
    };

    ListItem.prototype.calculateSizeBasedOnRatio = function () {
        if (this.parent.data.isAspectRatioEnabled) {
            var self = this;
            setTimeout(function () {
                var scrollbarWidth = 0;
                var hasScrollbar = self.$element[0].parentElement.parentElement.scrollHeight > self.$element[0].parentElement.parentElement.clientHeight ? true : false;
                if (hasScrollbar) {
                    scrollbarWidth = self.getScrollbarWidth(self.$element[0].parentElement.parentElement);
                }
                var height = (self.parent.data.ratioHeight / self.parent.data.ratioWidth) * (self.$element[0].offsetWidth + scrollbarWidth);
                self.$element
                    .css({
                        height: height
                    });
            }, 10);
        }
    };

    ListItem.prototype.postWindowResize = function () {
		this.calculateSizeBasedOnRatio();
    };

    ListItem.prototype.getScrollbarWidth = function(element) {
        return element.offsetWidth
        - element.clientWidth
        - parseFloat(getComputedStyle(element).borderLeftWidth)
        - parseFloat(getComputedStyle(element).borderRightWidth);
    };

    return ListItem;
});
